function multiInterscrollerCheck() {
    $(".interscroller-banner ins,.interscroller-banner .wrapAd").each(function( index ) {
        if($(this).find('.interscroller_box').length === 0) {
            $(this).parent('.interscroller-banner').remove();
        }
    });
}

$(document).ready(function() {
    if(checkSmallDevice()===false) {
        $(".lazy_leaderboard").lazyLoadAd({
            threshold:  20000,
            timeout:    500,
            //debug:      true
        });
        $(".lazy").lazyLoadAd({
            threshold:  200,
            timeout:    500,
            //debug:      true
        });
        $(".lazy_sznf").lazyLoadAd({
            threshold:  20000,
            timeout:    2000,
            //debug:      true
        });
        $(".lazy_b").lazyLoadAd({
            threshold: 400,
            timeout: 900
        });
        $(".lazy_l").lazyLoadAd({
            threshold: 10,
            timeout: 1000
        });
        $(".lazy_p").lazyLoadAd({
            threshold: 10,
            timeout: 1000
        });
    }

    $(".lazy_html").lazyLoadAd({
        threshold:  200,
        timeout:    500,
        //debug:      true
    });
    $(".lazy_html_popup").lazyLoadAd({
        forceLoad: true,
    });
    $(".lazy_is").lazyLoadAd({
        threshold:  0,
        timeout:    1000,
        onComplete: function() {
            setTimeout(multiInterscrollerCheck,20);
        },
        //debug:      true
    });
    $(".lazy_mobile").lazyLoadAd({
        threshold:  0,
        timeout:    200,
        //debug:      true
    });
    $(".lazy_mobile_sznf").lazyLoadAd({
        threshold:  20000,
        timeout:    2000,
        //debug:      true
    });

});

// $(document).ready(function(){
//     if(typeof tempNamespace['pozadiL'] === "undefined") {
//         $('.page-banner-side__left, .page-banner-side__right').hide();
//     }
// });

var checkSmallDevice = function(testWidth) {
    testWidth = (typeof testWidth !== 'undefined') ?  testWidth : 768;
    var deviceWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
    var smallDevice = false;
    if (deviceWidth < testWidth) {
        smallDevice = true;
    }
    return smallDevice;
};

$(document).ready(function() {
    if($('.adv[data-adv-zone]').length>0) {
        $.each($('.adv[data-adv-zone]'),function() {
            var s = document.createElement("script");
            s.textContent ="placeBanner('"+$(this).data('adv-name')+"', "+$(this).data('adv-zone')+");";
            $(this).toArray()[0].appendChild(s);
        });

    }
});
function stickyBoxSetHeight() {
    if ($('.sticky-insidebar').length > 0 && checkSmallDevice(992) === false) {
        if ($('.aside-main').length > 0 && $('.main-content').length > 0) {
            $('.aside-main').height('auto');
            if ($('.main-content').height() > ($('.aside-main').height())) {
                $('.aside-main').height($('.main-content').height());
            }
        }
    }
}

$(document).ready(function() {
    //stickyBoxSetHeight();
});

$(window).scroll(function() {
    stickyBoxSetHeight();
});

MutationObserver = window.MutationObserver || window.WebKitMutationObserver;

var observer = new MutationObserver(function(mutations, observer) {
    // fired when a mutation occurs
    stickyBoxSetHeight();
    // ...
});

// define what element should be observed by the observer
// and what types of mutations trigger the callback
observer.observe(document, {
    subtree: true,
    childList: true
});

// $('.aside-main').on("DOMSubtreeModified",function(){
//     stickyBoxSetHeight();
// });
// $('.aside-banner').on("DOMSubtreeModified",function(){
//     stickyBoxSetHeight();
// });
